@if(pages().length > 1){
<nav aria-label="Breadcrumb" class="breadcrumb mb-[1.5rem] mt-[1.5rem] sm:mt-0">
  <ul class="flex items-center gap-[0.5rem]">
    @for (page of pages(); track page.label; let last = $last) {
    <li
      class="flex items-center gap-[0.5rem] font-bold"
      [class.text-black]="last"
      [class.text-vinciGrey-600]="!last"
    >
      <a
        [routerLink]="page.url"
        class="!text-xs transition-colors duration-300"
        [class.hover:text-vinciGrey-700]="!last"
        [class.underline]="!last"
        >{{ page.label | transloco }}</a
      >
      @if (!last) {
      <span>/</span>
      }
    </li>
    }
  </ul>
</nav>
}
